export default {
  '锻炼记录列表':'鍛鍊記錄列表',
  '视频不存在':'視頻不存在',
}